import { IActionBase, IAPIState } from "../models/root.interface";
import { ADD_KEY, CHECK_KEY, ADD_SID } from "../actions/apiKey.action";


const initialState: IAPIState = {
   key:"",doesExist:null, sid:""
};
function keyReducer(state: IAPIState = initialState, action: IActionBase): IAPIState {
    switch (action.type) {
        case ADD_KEY: {
            return {...state, key:action.key};
        }
        case CHECK_KEY: {
            return {...state, doesExist:action.doesExist};
        }
        case ADD_SID: {
            return {...state, sid:action.sid};
        }
        default:
            return state;
    }
}


export default keyReducer;